// this file will be deprecated in favor of plotly
/* eslint no-unused-vars: 0 */
import React, { useEffect, useRef, useState } from 'react';
import { formatDate, formatDateYear } from '../../utils/helpers';

import Dygraph from 'dygraphs';
import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  graph: {
    width: '100%',
    display: 'flex',
  },
}));

export default ({ csv, colors, labels, title, ylabel, stackedGraph }) => {
  const classes = useStyles();
  const graphEl = useRef(null);

  const [graph, setGraph] = useState(null);

  const legendFormatter = (data) => {
    if (data.x === undefined) {
      return;
    }

    const date = formatDate(data.xHTML);
    let html = `<div>${date}</div>`;
    data.series.forEach((series) => {
      const yHTML = series.yHTML === undefined ? 'Undefined' : series.yHTML;
      const labeledData = `
        <div style="padding-top:1px;">
          <div style="display:flex;line-height:20px">${series.dashHTML} ${series.labelHTML}:</div>
          <div>${yHTML}</div>
        </div>`;
      html += labeledData;
    });
    return html;
  };

  const axisLabelFormatter = (x) => {
    return formatDateYear(x);
  };

  useEffect(() => {
    const g = new Dygraph(graphEl.current, csv, {
      legend: 'follow',
      hideOverlayOnMouseOut: true,
      showRangeSelector: true,
      strokeWidth: 1,
      title,
      legendFormatter,
      axes: {
        x: {
          axisLabelFormatter,
        },
      },
      colors: colors ? colors : null,
      labels,
      ylabel,
      stackedGraph: stackedGraph ? true : false,
    });
    setGraph(g);
  }, []);

  return <Grid className={classes.graph} ref={graphEl} size="grow" />;
};
